export class AssignmentStats {

    public primary_key: string = "assignment_execution_drive_distance";

    public assignment_execution_drive_distance: number;
    public assignment_execution_expenses: string;
    public assignment_execution_time_spend: string;
    public total_approved_assignments: string;
    public total_assignments: string;
}